// extracted by mini-css-extract-plugin
module.exports = {"bg":"Headers_bg__1OCvC","picture":"Headers_picture__3lk6o","textGreen":"Headers_textGreen__19gZc","textLight":"Headers_textLight__1d2tG"};